import { dv } from "@/lib/theme";

export const claimStyle = (s) => ({
  color: dv(s, "claim_color"), fontSize: `${dv(s, "claim_size")}px`, letterSpacing: `${dv(s, "claim_tracking")}em`,
  fontStyle: dv(s, "claim_italic") ? "italic" : "normal", fontWeight: dv(s, "claim_weight"),
  transform: `translate(${dv(s, "claim_x")}px, ${dv(s, "claim_y")}px)`,
});

/** Schriftzug neben dem Logo („CANARIAS“) – Text, Farbe, Größe und Verschiebung aus Admin → Design. */
export const SiteClaim = ({ s, className = "" }) => {
  if (!dv(s, "claim_show") || !dv(s, "claim_text")) return null;
  return <span className={`self-end font-serif -ml-8 -mb-1 relative z-10 drop-shadow-sm whitespace-nowrap ${className}`} style={claimStyle(s)} data-testid="nav-logo-claim">{dv(s, "claim_text")}</span>;
};
